"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.SET_EXPERIMENTS_BUCKET = exports.INIT_EXPERIMENTS_SUCCESS = exports.INIT_EXPERIMENTS_REQUEST = exports.INIT_EXPERIMENTS_FAILURE = exports.IMPRESSION_LOGGED = exports.GET_EXPERIMENT_VARIATIONS_SUCCESS = exports.GET_EXPERIMENT_VARIATIONS_REQUEST = exports.GET_EXPERIMENT_VARIATIONS_FAILURE = exports.GET_EXPERIMENTS_DEFINITIONS_SUCCESS = exports.GET_EXPERIMENTS_DEFINITIONS_REQUEST = exports.GET_EXPERIMENTS_DEFINITIONS_FAILURE = exports.CLEAR_EXPERIMENTS_BUCKET = exports.BUCKETING_LOGGED = void 0;
exports.bucketingLogged = bucketingLogged;
exports.clearExperimentsBucket = clearExperimentsBucket;
exports["default"] = exports.clearForcedExperiments = void 0;
exports.getExperimentVariations = getExperimentVariations;
exports.getExperimentsDefinitions = getExperimentsDefinitions;
exports.impressionLogged = impressionLogged;
exports.initExperiments = initExperiments;
exports.logImpression = exports.logBucketing = exports.initialState = void 0;
exports.setExperimentsBucket = setExperimentsBucket;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _querystring = require("querystring");

var _includes = _interopRequireDefault(require("lodash/includes"));

var _get = _interopRequireDefault(require("lodash/get"));

var _reduxActions = require("redux-actions");

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _api = _interopRequireDefault(require("../symbols/api"));

var _experiment = require("../utils/experiment");

var _handleActions;

// ------------------------------------
// Constants
// ------------------------------------
var SET_EXPERIMENTS_BUCKET = 'SFDC/EXPERIMENT/SET_EXPERIMENTS_BUCKET';
exports.SET_EXPERIMENTS_BUCKET = SET_EXPERIMENTS_BUCKET;
var CLEAR_EXPERIMENTS_BUCKET = 'SFDC/EXPERIMENT/CLEAR_EXPERIMENTS_BUCKET';
exports.CLEAR_EXPERIMENTS_BUCKET = CLEAR_EXPERIMENTS_BUCKET;
var IMPRESSION_LOGGED = 'SFDC/EXPERIMENT/IMPRESSION_LOGGED';
exports.IMPRESSION_LOGGED = IMPRESSION_LOGGED;
var BUCKETING_LOGGED = 'SFDC/EXPERIMENT/BUCKETING_LOGGED';
exports.BUCKETING_LOGGED = BUCKETING_LOGGED;
var GET_EXPERIMENT_VARIATIONS_REQUEST = 'SFDC/EXPERIMENT/GET_EXPERIMENT_VARIATIONS_REQUEST';
exports.GET_EXPERIMENT_VARIATIONS_REQUEST = GET_EXPERIMENT_VARIATIONS_REQUEST;
var GET_EXPERIMENT_VARIATIONS_SUCCESS = 'SFDC/EXPERIMENT/GET_EXPERIMENT_VARIATIONS_SUCCESS';
exports.GET_EXPERIMENT_VARIATIONS_SUCCESS = GET_EXPERIMENT_VARIATIONS_SUCCESS;
var GET_EXPERIMENT_VARIATIONS_FAILURE = 'SFDC/EXPERIMENT/GET_EXPERIMENT_VARIATIONS_FAILURE';
exports.GET_EXPERIMENT_VARIATIONS_FAILURE = GET_EXPERIMENT_VARIATIONS_FAILURE;
var GET_EXPERIMENTS_DEFINITIONS_REQUEST = 'SFDC/EXPERIMENT/GET_EXPERIMENTS_DEFINITIONS_REQUEST';
exports.GET_EXPERIMENTS_DEFINITIONS_REQUEST = GET_EXPERIMENTS_DEFINITIONS_REQUEST;
var GET_EXPERIMENTS_DEFINITIONS_SUCCESS = 'SFDC/EXPERIMENT/GET_EXPERIMENTS_DEFINITIONS_SUCCESS';
exports.GET_EXPERIMENTS_DEFINITIONS_SUCCESS = GET_EXPERIMENTS_DEFINITIONS_SUCCESS;
var GET_EXPERIMENTS_DEFINITIONS_FAILURE = 'SFDC/EXPERIMENT/GET_EXPERIMENTS_DEFINITIONS_FAILURE';
exports.GET_EXPERIMENTS_DEFINITIONS_FAILURE = GET_EXPERIMENTS_DEFINITIONS_FAILURE;
var INIT_EXPERIMENTS_REQUEST = 'SFDC/EXPERIMENT/INIT_EXPERIMENTS_REQUEST';
exports.INIT_EXPERIMENTS_REQUEST = INIT_EXPERIMENTS_REQUEST;
var INIT_EXPERIMENTS_SUCCESS = 'SFDC/EXPERIMENT/INIT_EXPERIMENTS_SUCCESS';
exports.INIT_EXPERIMENTS_SUCCESS = INIT_EXPERIMENTS_SUCCESS;
var INIT_EXPERIMENTS_FAILURE = 'SFDC/EXPERIMENT/INIT_EXPERIMENTS_FAILURE'; // ------------------------------------
// Initial State
// ------------------------------------

exports.INIT_EXPERIMENTS_FAILURE = INIT_EXPERIMENTS_FAILURE;
var initialState = {
  bucket: {},
  forcedBucket: {},
  definitions: [],
  loggedImpressions: [],
  loading: false,
  loaded: false,
  error: null
}; // ------------------------------------
// Reducer
// ------------------------------------

exports.initialState = initialState;

var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _handleActions[SET_EXPERIMENTS_BUCKET] = function (state, action) {
  return (0, _extends2["default"])({}, state, {
    bucket: (0, _extends2["default"])({}, action.payload)
  });
}, _handleActions[GET_EXPERIMENT_VARIATIONS_SUCCESS] = function (state, action) {
  return (0, _extends2["default"])({}, state, {
    bucket: action.payload.experiments
  });
}, _handleActions[CLEAR_EXPERIMENTS_BUCKET] = function (state) {
  return (0, _extends2["default"])({}, state, {
    loading: true,
    bucket: initialState.bucket,
    forcedBucket: initialState.forcedBucket
  });
}, _handleActions[INIT_EXPERIMENTS_REQUEST] = function (state) {
  return (0, _extends2["default"])({}, state, {
    loading: true
  });
}, _handleActions[INIT_EXPERIMENTS_SUCCESS] = function (state) {
  return (0, _extends2["default"])({}, state, {
    loading: false
  });
}, _handleActions[INIT_EXPERIMENTS_FAILURE] = function (state) {
  return (0, _extends2["default"])({}, state, {
    loading: false,
    error: true
  });
}, _handleActions[GET_EXPERIMENTS_DEFINITIONS_REQUEST] = function (state) {
  return (0, _extends2["default"])({}, state, {
    loading: true
  });
}, _handleActions[GET_EXPERIMENTS_DEFINITIONS_SUCCESS] = function (state, action) {
  return (0, _extends2["default"])({}, state, {
    definitions: (0, _get["default"])(action, 'payload.definitions', []),
    loading: false,
    loaded: true
  });
}, _handleActions[GET_EXPERIMENTS_DEFINITIONS_FAILURE] = function (state) {
  return (0, _extends2["default"])({}, state, {
    loading: false,
    loaded: false,
    error: true
  });
}, _handleActions[IMPRESSION_LOGGED] = function (state, action) {
  return (0, _extends2["default"])({}, state, {
    loggedImpressions: [].concat(state.loggedImpressions, [(0, _get["default"])(action, 'payload.experimentName', null)])
  });
}, _handleActions), initialState); // ------------------------------------
// Actions
// ------------------------------------


exports["default"] = _default;

function getExperimentVariations(namespace, experiments) {
  var _ref;

  return _ref = {}, _ref[_api["default"]] = {
    types: [GET_EXPERIMENT_VARIATIONS_REQUEST, GET_EXPERIMENT_VARIATIONS_SUCCESS, GET_EXPERIMENT_VARIATIONS_FAILURE],
    method: 'GET',
    endpoint: "/api/experiments/" + namespace + "?" + (0, _querystring.stringify)({
      experiments: experiments
    })
  }, _ref;
}

function getExperimentsDefinitions() {
  var _ref2;

  return _ref2 = {}, _ref2[_api["default"]] = {
    types: [GET_EXPERIMENTS_DEFINITIONS_REQUEST, GET_EXPERIMENTS_DEFINITIONS_SUCCESS, GET_EXPERIMENTS_DEFINITIONS_FAILURE],
    method: 'GET',
    endpoint: '/api/experiments/definitions'
  }, _ref2;
}

function initExperiments(data) {
  var _ref3;

  return _ref3 = {}, _ref3[_api["default"]] = {
    types: [INIT_EXPERIMENTS_REQUEST, INIT_EXPERIMENTS_SUCCESS, INIT_EXPERIMENTS_FAILURE],
    method: 'POST',
    endpoint: '/api/experiments/init',
    data: data
  }, _ref3;
}

function setExperimentsBucket(payload) {
  return {
    type: SET_EXPERIMENTS_BUCKET,
    payload: payload
  };
}

function clearExperimentsBucket(payload) {
  return {
    type: CLEAR_EXPERIMENTS_BUCKET,
    payload: payload
  };
}

function bucketingLogged(payload) {
  return {
    type: BUCKETING_LOGGED,
    payload: payload
  };
}

function impressionLogged(experimentName, variationName) {
  return {
    type: IMPRESSION_LOGGED,
    payload: {
      experimentName: experimentName,
      variationName: variationName
    }
  };
}

var logBucketing = function logBucketing() {
  return function (dispatch, getState) {
    var _getState = getState(),
        experiments = _getState.experiments;

    (0, _experiment.logExperimentBucketing)(experiments.bucket);
    dispatch(bucketingLogged(experiments.bucket));
  };
};

exports.logBucketing = logBucketing;

var logImpression = function logImpression(experimentName) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        experiments = _getState2.experiments;

    if (!(0, _includes["default"])(experiments.loggedImpressions, experimentName)) {
      var variationName = (0, _experiment.getExperimentTreatment)(experimentName, experiments.bucket);

      if ((0, _experiment.isExperimentActive)(experimentName, experiments.bucket)) {
        (0, _experiment.logExperimentImpression)(experimentName, variationName);
        dispatch(impressionLogged(experimentName, variationName));
      }
    }
  };
};

exports.logImpression = logImpression;

var clearForcedExperiments = function clearForcedExperiments() {
  return function (dispatch) {
    var cookies = new _universalCookie["default"]();
    cookies.remove('visit', {
      path: '/'
    });
    cookies.remove('visitor', {
      path: '/'
    });
    cookies.remove('visitor_id', {
      path: '/'
    });
    cookies.remove('sf_forced_experiments', {
      path: '/'
    });
    dispatch(clearExperimentsBucket());
  };
};

exports.clearForcedExperiments = clearForcedExperiments;